import axios from 'axios';

let BASE_URL = process.env.REACT_APP_INT_URL;

const mikrokomReq = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

const loginMikrokom = async (username, password, domainCode) => {
    const response = await mikrokomReq.post('/mikrokom-altos/login', { username, password, domainCode });
    return response;
};

const getCompanyAndPeriodList = async (token) => {
    const response = await mikrokomReq.post('/mikrokom-altos/getCompaniesAndPeriods', { token });
    return response;
};

export { loginMikrokom, getCompanyAndPeriodList };
